var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentUser)?_c('BContainer',{staticClass:"px-0",attrs:{"fluid":""}},[_c('Task',{staticClass:"my-3",attrs:{"activity":{
      activity_name: _vm.taskInformation.activity_name,
      crop_name: _vm.taskInformation.crop_name,
      total_buyers: _vm.taskInformation.customers_bought_count
    },"current-progress":{
      event: _vm.taskInformation.events_count,
      customer: _vm.taskInformation.customers_attended_count,
      hectare: _vm.taskInformation.total_actual_hectares,
      cost: _vm.taskInformation.total_actual_costs,
      sales: _vm.taskInformation.total_actual_sales
    },"total-progress":{
      event: _vm.taskInformation.event_plan,
      customer: _vm.taskInformation.total_customer_plan,
      hectare: _vm.taskInformation.total_hectare_plan,
      cost: _vm.taskInformation.total_budget_plan,
      sales: _vm.taskInformation.total_sales_plan
    },"loading":_vm.state.busy},scopedSlots:_vm._u([{key:"footer-loader",fn:function(){return [_c('div',{staticClass:"d-flex justify-content-start gap-2 mt-3"},[_c('BSkeleton',{attrs:{"width":"62px","height":"20px"}})],1)]},proxy:true},{key:"footer",fn:function(){return [_c('div',{staticClass:"d-flex justify-content-start gap-2 mt-3"},[_c('BBadge',{attrs:{"variant":"dark-light"}},[_vm._v(" "+_vm._s(_vm.monthShortFormatter(_vm.taskInformation.schedule))+" ")])],1)]},proxy:true}],null,false,1572547622)}),(_vm.taskInformation.id)?_c('Events',{attrs:{"task":_vm.taskInformation}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }